// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import { StyledButtonsWrapper, StyledTitleModal } from '../Styled';
import { Button } from '@/ui';

// Models
import { IUserProfile } from '@/models/users.model';

type TUserModal = {
  isOpened: boolean;
  closeModal: () => void;
  currentUserDetails: IUserProfile;
  handleToggleActiveStatus: () => Promise<void>;
};

const UserModal = ({ isOpened, closeModal, currentUserDetails, handleToggleActiveStatus }: TUserModal) => {
  const { t } = useTranslation(['usersList']);
  const userStatusChangeText = currentUserDetails?.active ? 'users_list_block_user' : 'users_list_unblock_user';
  const userStatusChangeButtonText = currentUserDetails?.active
    ? 'users_list_block_button'
    : 'users_list_unblock_button';

  return (
    <Modal visible={isOpened} onCancel={closeModal} size={ModalSize.LARGE}>
      <StyledTitleModal>
        {t(userStatusChangeText, {
          name: currentUserDetails?.full_name,
        })}
      </StyledTitleModal>
      <StyledButtonsWrapper>
        <Button onClick={closeModal} type="primary">
          {t('users_list_back')}
        </Button>
        <Button onClick={handleToggleActiveStatus} type="text">
          {t(userStatusChangeButtonText)}
        </Button>
      </StyledButtonsWrapper>
    </Modal>
  );
};

export default UserModal;
